import React, { useEffect } from "react";
import { LoadingButton } from "../../../../Components/header/form";
import { useDispatch, useSelector } from "react-redux";
import {
  getLiveDetailAction,
  setLiveDetail,
} from "../../../../store/slices/liveDetailSlice";
import { disconnectMeetApi, googleMeetConnectApi } from "../../../../services/goLive";
import { toastMessage } from "../../../../utils/toastMessage";
import axios from "axios";
import { setJwtToken } from "../../../../config/AxiosInstance";

const ConnectMeet = () => {
  const { liveDetail } = useSelector((state) => state?.liveDetail);
  const dispatch = useDispatch();
  // console.log('liveDetail', liveDetail)

  const disconnectMeetHandler = async () => {
    if (liveDetail?._id) {
      try {
        const { data } = await disconnectMeetApi(liveDetail?._id);
        const { success, message } = data;
        toastMessage(
          success ? "Google Meet Disconnect Successfully" : message,
          success ? "success" : "error",
          "disconnectMeetHandler"
        );
        if (success) {
          dispatch(setLiveDetail({}));
        }
      } catch (e) {
        console.log(e.message);
      }
    }
  };

  const connectMeetHandler = async () => {
    try {
      // const { data } = await axios.get(
      //   `${process.env.REACT_APP_API_URL}user/live/google-meet-auth`,
      //   setJwtToken()
      // );
      const { data } = await googleMeetConnectApi()
      const { data: liveMeetData, success, message, meta } = data;
      if (success) {
        dispatch(setLiveDetail(liveMeetData));
      } else {
        // console.log('else--------------->>>>>>>', data, 'data main link', data?.data)
        const url = data?.data
        if (url) {
          window.open(url, "_blank");
        } else {
          console.error(
            "Authentication failed, but no URL provided:",
            data?.message
          );
        }
      }
      throw new Error(message || "Failed to fetch course details.");
    } catch (error) {
      // console.log(' catch error----->', error)
      if (
        !error?.response?.data?.success &&
        error?.response?.data?.message === "Authentication failed"
      ) {
        // console.log('error', error)
        const url = error?.response?.data?.data;
        if (url) {
          window.open(url, "_blank");
        } else {
          console.error(
            "Authentication failed, but no URL provided:",
            error?.response?.data
          );
        }
      } else {
        console.error(
          "Error does not match 'Authentication failed':",
          error?.response?.data, error
        );
      }
      console.error(error?.message);
    }
  };

  // console.log(liveDetail, "LiveDetail");

  return (
    <>
      {" "}
      <div className="parent_msg">
        <ul>
          <li>Connect Meet</li>
          <li>
            <div className="button_wrap">
              <LoadingButton
                type="button"
                className="button"
                onClick={() => {
                  if (liveDetail?._id) {
                    disconnectMeetHandler();
                  } else {
                    connectMeetHandler();
                  }
                }}
              >
                {liveDetail?._id ? "Disconnect Meet" : "Connect Meet"}
              </LoadingButton>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
};

export default ConnectMeet;
